<template>
  <div id="telesecretary-widget"></div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "TelesecretaryWidget",

  setup() {
    onMounted(() => {
      const scripts = [
        "https://321med14.com/cdn/server/e8663be12fc755cbefebfdd604f1d382c6b3a84d/321med.js",
        "https://321med-cdn.com/321med.js"
      ];

      scripts.forEach(src => {
        const script = document.createElement("script");
        script.src = src;
        script.async = false;
        document.body.appendChild(script);
      });
    });
  }
});
</script>